import {
  Box,
  Container,
  Grid,
  GridItem,
  Image,
  Input,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import ArrowRight from "common/assets/img/arrowRightBlue.png";
import FacebookIcon from "common/assets/svg/FacebookIcon";
import InstagramIcon from "common/assets/svg/InstagramIcon";
import LinkedIcon from "common/assets/svg/LinkedinIcon";
import TwitterIcon from "common/assets/svg/TwitterIcon";
import { landingPageConstants } from "common/landingPageConstants";

const Footer = () => {
  return (
    <>
        <Box className="footerSectionBlank">
          
        </Box>
    </>
  );
};
export default Footer;
